<template>

<CuotasModal
  :show="modalCuotas"
  :cuotas="itemsSinReferencia"
  :importe="!esVenta ? producto.precio : precio"
  :esVenta="esVenta"
  @cancelled="modalCuotas=$event"
  @deleteCuota="eliminarDirecta()"
  @guardar="guardarCuotas"
  ref="cuotasModal"
/>

<CCard :class="!esVenta ? 'mt-4' : 'border-0'">
  <CCardHeader>
    <div class="d-flex align-items-center justify-content-between">
      <span class="title-card-list">
        <CIcon name="cil-money" class="me-2" />
        {{ title }}
      </span>

    <div class="mt-1 header-button-container">
      <CButton :disabled="loading" class="send-button" size="sm" color="primary" @click="cuotasModal()">
          {{ esVenta ? 'Modificar' : 'Nueva / Modificar'}}
      </CButton>
    </div>
    </div>
  </CCardHeader>
  <spinner-ttt :show="loading"></spinner-ttt>
  <CCardBody>
    <CSmartTable
      v-if="loaded"
      v-model:items="items"
      :columns="campos"
      :tableProps="{
            hover: true,
            striped: true,
            responsive: configResponsive
          }"
      :selectable="!esVenta"
      clickable-rows
      @row-click="cuotasModal"
      :no-items-label="'Sin resultados'"
      @selected-items-change="items => itemsSeleccionados = items"
    >


    <template #opciones="{item}">
      <td class="px-0">
        <div class="dropdown">
          <CIcon class="dropdown-toggle" size="lg" name="cil-options" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" />
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li @click="eliminar(item)"><span class="dropdown-item"><CIcon size="lg" name="cil-trash" class="me-2 text-danger"/>Eliminar </span></li>
          </ul>
        </div>

      </td>
    </template>
    </CSmartTable>
    <h3 class="text-center mt-4 mb-5" v-if="items.length < 1">
      Sin resultados
    </h3>
    <div v-if="!esVenta" d-flex flex-row class="acciones-disponibles ms-3">
          <div class="col-12 col-md-auto">
            <CDropdown>
              <CDropdownToggle size="sm" color="primary">Acciones Globales</CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem @click="modalDelete()"><CIcon name="cil-trash" class="me-2 text-danger"/> Eliminar</CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </div>
    </div>
  </CCardBody>
</CCard>

<toast ref="toast"></toast>
</template>

<script>
import { formatNum, formatDateCustom } from '@/app/shared/utils/tools';
import { CUOTA_FIELDS, CONFIG_PANEL } from '@/config';

export default {
  name: 'CuotasList',
  props: {
    elemento: { type: String, default: 'Cuotas' },
    title: { type: String, default: 'Cuotas' },
    loading: Boolean,
    loaded: Boolean,
    cuotas: { type: Array, default() {return[]}, required: true },
    producto: {type:Object, required: false},
    esVenta: {type:Boolean, default: false},

    rows: { type: Number, default: 0 },
    currentPage:  { type: Number, default: 1 },
    perPage:  { type: Number, default: 25 },
    total_paginas:  { type: Number, default: 1 },
  },
  data() {
    return {
      formatDateCustom,
      campos: [
        // { key: "id", label: "Id", sorter: true ,  _style: 'width:5%' },
        {key: 'fecha', label: 'Fecha'},
        {key: 'tratamiento', label: 'Tratamiento'},
        {key: 'importe', label: 'Importe'},
        {key: 'saldo', label: 'Saldo'},
      ],
      element: 'Cuota',
      itemsSeleccionados: [],
      itemsSinReferencia: [],

      modalCuotas: false
    }
  },

  mounted() {
    if(this.esVenta) {
      this.campos.push({key: 'importe_pendiente', label: 'Importe Pendiente'})
      this.campos.push({key: 'fecha_vencimiento', label: 'Fecha de vencimiento'})
    } else {
      this.campos.push({key: 'opciones', label: '', sorter: false});
    }
  },
  computed: {
    items:{
      get: function () {
        return this.cuotas;
      },
      set: function (newValue) {
        this.$emit("update:cuotas", newValue);
      },
    },
    currentPageSon: {
      get: function() {
        return this.currentPage;
      },
      set: function(newValue) {
        this.$emit('update:currentPage', newValue)
      }
    },
    loadingList: {
      get: function() {
        return this.loading;
      },
      set: function(newValue) {
        this.$emit('update:loading', newValue)
      }
    },
    configResponsive() {
      return CONFIG_PANEL.responsive;
    },
    precio() {
      if(!this.items || this.items.length < 1) return 0;

      const precio = this.items.reduce((initialValue, currentValue) => {

        return Number(initialValue.importe_final) + Number(currentValue.importe_final)
      })

      return precio;
    }
  },
  methods: {
    getRowCount: function() {
      return this.rows;
    },

    cuotasModal(item = null, index, column, e) {
      //Se obtienen las cuotas de manera que no se obtengan por referencia para que al salir del modal se reseteen
      if(!item || ((item && !['indice', undefined].includes(column)) || esVenta)) {
        this.itemsSinReferencia = [];
        this.items.forEach(item => {
          this.itemsSinReferencia.push({...item});
        });
        if (!item && this.itemsSinReferencia.length < 1) {
          this.itemsSinReferencia.push({...CUOTA_FIELDS, indice: `#${this.itemsSinReferencia.length + 1}` });
        }

        this.modalCuotas = true;
      }
    },

    formatNum(n) {
      return formatNum(n);
    },

    guardarCuotas(items) {
      this.cerrarModal();
      this.$emit('guardarCuotas', items);
    },

    getDescuento(item) {
      const descuento = (item.descuento_importe * 100) / item.importe;

      return `${descuento.toFixed(2)}%`
    },

    checkearSeleccionados() {
      this.items.map(item => item._selected = false);

      this.itemsSeleccionados.forEach(item => {
        this.items[this.items.indexOf(this.items.filter(i => i.id == item.id)[0])]._selected = item._selected;
      });

      this.items = [...this.items];

      return this.items.filter(item => item._selected === true);
    },

    modalDelete(){
      const checked = this.checkearSeleccionados();

      if(checked.length){
        this.$emit('delete', true)
      } else {
        this.$refs.toast.showToast(`No se ha seleccionado una cuota para eliminar.`, null, 'warn', '5000');
      }
    },

    eliminar(item) {
      this.$emit('deleteCuota', item);
    },

    eliminarDirecta(item) {
      this.$emit('deleteCuotaDirecta', item);
    },

    cerrarModal() {
      this.$refs.cuotasModal.cerrarModal()
    }
  }
}
</script>

<style>

</style>
